<template>
    <div>
    </div>
</template>

<script>

import { doAuth, doAuth2 } from '@/api/authorized'
import { getToken } from '@/utils/auth'
import Multiselect from 'vue-multiselect'
export default {
    name: 'Authorized',
    data () {
        return {
            redirectPage: '',
            redirectUrl: '',
            code: null,
            state: null,
            retUrl: null,
            targetUrl: null,
            host: window.location.host,
            redirectUrl: null
        }
    },
    components: { Multiselect },
    created() {
        
        if (window.location.host.indexOf('localhost') != -1) {
            this.host = '127.0.0.1:3000'
        }
        this.host = '7f74-61-222-126-183.ngrok-free.app'
        
        this.redirectPage = this.$route.query.redirect
        this.redirectUrl = "https://" + this.host + "/auth?redirect=" + this.redirectPage.replace("/", "")
        this.code = this.$route.query.code
        this.state = this.$route.query.state

        if (this.redirectPage == null && this.code == null) {
            return
        }

        if (this.code != null) {

            let req = {
                page: this.redirectPage,
                code: this.code,
                redirectUrl: this.redirectUrl
            }

            doAuth2(req).then((res) => {
                if (res.Success) {
                    if (res.AccessToken) {
                        this.$store.dispatch('resetToken', res.AccessToken.access_token)
                        this.$store.dispatch('resetRefreshToken', res.AccessToken.refresh_token)
                        this.$router.push(this.redirectPage).catch(() => {})
                    }
                }
            })
        } else if (this.redirectPage != null && this.code == null) {

            let req = {
                page: this.redirectPage
            }
            doAuth(req).then((res) => {
                if (res.Success) {
                    let targetUrl = res.TargetUrl.replace("{{redirect_url}}", this.redirectUrl)
                    //window.location.href = targetUrl
                }
            })
        }
    }
}
</script>
